import importerReducers from 'src/modules/shared/importer/importerReducers';
import actions from 'src/modules/temaComunicacion/importer/temaComunicacionImporterActions';

export default importerReducers(actions);
